var offcanvas = document.getElementById('navbarNavDropdown');
var bodyEl = document.getElementsByTagName("body");
offcanvas.addEventListener('shown.bs.offcanvas', function () {
    bodyEl[0].classList.add('dont-scroll');
})

offcanvas.addEventListener('hidden.bs.offcanvas', function () {
    bodyEl[0].classList.remove('dont-scroll');
    let hamburger = document.getElementById('hamburger');
    console.log(hamburger);
    hamburger.classList.remove('open');
})
